(function() {
    'use strict';

    angular.module('order')
        .controller('AltPreviewModalController', AltPreviewModalController);

    AltPreviewModalController.$inject = ['lodashService', '$uibModalInstance', 'orderProduct', 'previewLoadingConst'];

    function AltPreviewModalController(lodashService, $uibModalInstance, orderProduct, previewLoadingConst) {
        var self = this;

        self.orderProduct = orderProduct;
        self.ok = ok;
        self.previewLoading = true;
        self.pagesLoaded = 0;
        self.pagesLoadingText = previewLoadingConst.pagesLoadingText;

        // activate();
        //
        // function activate() {
        //     lodashService.forEach(self.orderProduct.tech_lines, function(tl) {
        //         tl.is_active = null;
        //     });
        //     console.log("ZZZ", self.orderProduct);
        // }

        function ok() {
            self.orderProduct = null;
            // $uibModalInstance.close();
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
